import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send"; // Import Send icon from MUI icons

const MessagePopup = ({ modalOpen, okayHandler, message }) => {
  return (
    <Dialog
      open={modalOpen}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          minWidth: "400px",
          padding: "20px",
        },
      }}
    >
      <DialogContent sx={{ paddingBottom: "20px" }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px", // Match the font size of the body text
            fontFamily: "Roboto, sans-serif", // Ensure font family is consistent
            color: "#333", // Match text color
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      {/* Add Divider above the buttons */}
      <Divider />

      {/* Dialog Actions - Align both buttons to the right corner */}
      <DialogActions sx={{ justifyContent: "flex-end", padding: "10px 24px" }}>
        {/* Login Button (Blue) with Send Icon */}
        <Button
          onClick={okayHandler} // Confirm the logout action
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: "bold",
            fontSize: "14px", // Same font size for Yes button text
            fontFamily: "Roboto, sans-serif", // Same font family
            color: "white",
            backgroundColor: "#49A3FF",
            display: "flex",
            alignItems: "center",
            padding: "5px 15px",
          }}
        >
          <SendIcon sx={{ marginRight: "8px" }} />{" "}
          {/* Replace icon with Send icon */}
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessagePopup;